import React from 'react'
import healthcare1 from '../images/infusion1.png';
import healthcare2 from '../images/infusion2.png';
import healthcare3 from '../images/coresync3.png';
import OurPartner from '../pages/components/OurPartner';

function InFusion() {
    return (
        <>
            <section id="portfolio" className="container my-5">
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="px-3 fw-bold responsive-heading">
                        <span className="highlight-orange">InFusion</span> – Customised Project Management ERP Software
                    </div>
                </div>
            </section>

            <section className="container my-5">

                {/* Section 1: Project Overview */}
                <div className="row g-0 overflow-hidden shadow rounded">
                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare1}
                            alt="Project Management ERP Overview"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">InFusion</span> – Project Management ERP Software
                        </h1>

                        <p className="mb-3 ps-1">
                            InFusion is an advanced, fully customised project management ERP system designed to streamline
                            planning, task allocation, team collaboration, tracking, budgeting, and multi-department workflow
                            automation. It centralises all project-related operations into a single smart dashboard — enabling
                            companies to deliver projects faster, with higher accuracy and improved resource utilisation.
                        </p>

                        <p className="mb-3 ps-1">
                            The platform supports complete lifecycle management: project creation, scheduling, workload balancing,
                            document control, client communication, timeline tracking, milestone automation, and performance
                            analytics. With integrated reporting and real-time visibility, InFusion helps teams maintain control
                            over deadlines, productivity, and cost efficiency.
                        </p>

                        <p className="mb-3 ps-1 fw-bold">
                            <span className="highlight-orange">Business Impact:</span> Organisations using InFusion experienced
                            <span className="highlight-orange"> 40–60% faster project delivery cycles</span>, reduced overhead costs
                            by <span className="highlight-orange">30–45%</span>, and achieved a
                            <span className="highlight-orange"> 2× improvement in team productivity</span> through automation,
                            structured workflows, and real-time monitoring.
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>
                </div>

                {/* Section 2: Summary & Team Info */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">Client:</span> InFusion
                        </h1>

                        <h4 className="fw-bold mb-1 highlight-orange">Country</h4>
                        <p className="mb-3 ps-3">USA</p>

                        <h4 className="fw-bold mb-1 highlight-orange">Technology & Purpose</h4>
                        <p className="mb-3 ps-3">
                            Project Automation Engine, Workflow Management, Task Orchestration System, React, Node.js,
                            Firebase, REST APIs, Scheduling Algorithms, Resource Forecasting, Real-Time Project Analytics Dashboard
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Domain</h4>
                        <p className="mb-3 ps-3">Project Management • Workflow Automation • ERP</p>

                        <h4 className="fw-bold mb-1 highlight-orange">Team Involvement</h4>
                        <p className="mb-3 ps-3">
                            UI/UX Designer, 2 Frontend Engineers, Backend Architect, Project Consultant,
                            Automation Engineer, QA Engineer
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Duration</h4>
                        <p className="mb-4 ps-3">5 Months</p>

                        <p className="mb-4 ps-3">
                            The InFusion Project Management ERP was built to simplify complex project workflows, automate task
                            allocation, improve cross-team collaboration, and ensure real-time progress monitoring. The system
                            integrates project scheduling, workload management, cost tracking, document control, and client
                            communication into one unified ecosystem.
                            <br /><br />
                            With smart alerts, performance analytics, milestone visualization, and seamless multi-team coordination,
                            InFusion helps organizations increase delivery accuracy, reduce delays, and maintain complete operational
                            transparency. Designed with scale in mind, the platform supports enterprise-level project loads with
                            reliability and efficiency.
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>

                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare2}
                            alt="Project Management UI"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>
                </div>

                {/* Section 3: Process & Key Features */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare3}
                            alt="Project Management Features"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3">
                            <span className="highlight-orange">Process</span>
                        </h1>

                        <p className="mb-3 ps-1">
                            We architected the InFusion platform with a project-first ERP design focused on automation,
                            clarity, and multi-team collaboration. The backend integrates project scheduling algorithms,
                            resource forecasting engines, role-based workflows, document management, and real-time
                            synchronization — ensuring every project runs smoothly end-to-end.
                        </p>

                        <p className="mb-3 ps-1">
                            The UI/UX was designed to reduce operational complexity and make project tracking effortless.
                            Teams can manage tasks, assign workloads, upload documents, track timelines, review milestones,
                            and analyze performance — all from a clean, intuitive, and responsive interface.
                        </p>

                        <h4 className="fw-bold mb-2 highlight-orange">Key Features</h4>
                        <ul className="ps-3 mb-4">
                            <li className="mb-1">Project creation, planning & milestone tracking</li>
                            <li className="mb-1">Automated task allocation & workload balancing</li>
                            <li className="mb-1">Team collaboration board with real-time updates</li>
                            <li className="mb-1">Resource management & utilization analytics</li>
                            <li className="mb-1">Smart alerts for deadlines, delays & dependencies</li>
                            <li className="mb-1">Budget tracking & project cost management</li>
                            <li className="mb-1">Document sharing & version control</li>
                            <li className="mb-1">Interactive project timeline & Gantt view</li>
                        </ul>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Get Started
                        </a>
                    </div>
                </div>

                <OurPartner />

            </section>



        </>
    )
}

export default InFusion